import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

// import { DynamicFormGroupsElemComponent } from './dynamic-form-groups-elem.component';

@Component({
    selector: 'dynamic-form-groups',
    template: `
    <form novalidate (ngSubmit)="onSubmit(form.value)" [formGroup]="form" fxLayout="column">
      <div *ngFor="let objectProps of objectGroups" fxLayout="{{objectProps.layout||'column'}}" fxFlex="{{objectProps.fxFlex||'none'}}" fxLayoutGap="20px" fxLayoutWrap>
				<h4 *ngIf="objectProps.label > ''">{{objectProps.label}}</h4>
        <div *ngIf="evaluate(objectProps.ngIf)" id="{{objectProps.key}}" fxLayout="{{objectProps.layout||'column'}}">
          <div *ngFor="let prop of objectProps.fields" fxLayout="{{prop.layout||'column'}}" fxFlex="{{prop.fxFlex||'none'}}" class="dyn-form-group {{prop.key}} {{prop.class}}">
              <div [ngSwitch]="prop.type">
                <div *ngSwitchCase="'group'">
										<dynamic-form-groups-elem [dataObjectElem]="prop" [dataObject]="dataObject" [form]="form" (change)="onChange"></dynamic-form-groups-elem>
								</div>
								<div *ngSwitchCase="'hidden'">
                      <input [formControlName]="prop.key"
											(change)="onChange(prop)"
                      [id]="prop.key" [type]="prop.type">
                </div>
                <div *ngSwitchCase="'text'" fxFlex="{{prop.fxFlex||'none'}}">
                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"fxFlex="{{prop.fxFlex||'none'}}" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
                        <input matInput placeholder="{{prop.label}}"
												[readonly]="prop.readonly||dataObject.readonly"
                        [formControlName]="prop.key"
												(change)="onChange(prop)"
                        [id]="prop.key" [type]="prop.type" fxFlex="{{prop.fxFlex||'none'}}">
                    </mat-form-field>
                </div>
                <div *ngSwitchCase="'textarea'" fxFlex="{{prop.fxFlex||'none'}}">
                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"fxFlex="{{prop.fxFlex||'none'}}" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
                        <textarea matInput placeholder="{{prop.label}}" rows="{{prop.rows||'3'}}" autosize
												[readonly]="prop.readonly||dataObject.readonly"
                        [formControlName]="prop.key"
												(change)="onChange(prop)"
                        [id]="prop.key" [type]="prop.type"></textarea>
                    </mat-form-field>
                </div>
                <div *ngSwitchCase="'number'" fxFlex="{{prop.fxFlex||'none'}}">
                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"fxFlex="{{prop.fxFlex||'none'}}" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
                        <input matInput placeholder="{{prop.label}}"
												[readonly]="prop.readonly||dataObject.readonly"
                        [formControlName]="prop.key"
												(change)="onChange(prop)"
                        [id]="prop.key" [type]="prop.type">
                    </mat-form-field>
                </div>
                <div *ngSwitchCase="'date'" fxFlex="{{prop.fxFlex||'none'}}">
                    <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"fxFlex="{{prop.fxFlex||'none'}}" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
                        <input matInput [matDatepicker]=picker placeholder="{{prop.label}}"
												[readonly]="prop.readonly||dataObject.readonly"
                        [formControlName]="prop.key"
												(change)="onChange(prop)"
                        [id]="prop.key">
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    </mat-form-field>
                </div>
								<div *ngSwitchCase="'checkbox'" fxFlex="{{prop.fxFlex||'none'}}">
                    <section fxFlex="{{prop.fxFlex||'none'}}" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
                        <mat-checkbox (change)="onChange(prop)"
                        [formControlName]="prop.key"
                        [id]="prop.key">{{prop.label}}</mat-checkbox>
                    </section>
                </div>

                <div *ngSwitchCase="'radio'" fxFlex="{{prop.fxFlex||'none'}}">
                <div _ngcontent-c20="" style="height: 20px;" fxFlex="{{prop.fxFlex||'none'}}" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
                  <label _ngcontent-c20="" style="transform: translateY(-1.28125em) scale(0.75) perspective(100px) translateZ(0.001px);-ms-transform: translateY(-1.28125em) scale(0.75);width: 133.33333333%;margin: 14px 0 0 -66px;font-weight: 100;color: #666;">
                        {{prop.label}}
                      </label>
                    </div>
                    <mat-radio-group [formControlName]="prop.key" [name]="prop.key" fxLayout="column">
                      <mat-radio-button [value]="option.value" *ngFor="let option of prop.options" (change)="onChange(prop)">
                        {{option.label}}
                      </mat-radio-button>
                    </mat-radio-group>
                </div>

                <div *ngSwitchCase="'select'" fxFlex="{{prop.fxFlex||'none'}}" [ngClass]="['dyn-form-elem', prop.class||'', prop.key]">
                  <mat-form-field [appearance]="uiSvc ? uiSvc.appearance : 'fill'"fxFlex="{{prop.fxFlex||'none'}}">
                    <mat-select [formControlName]="prop.key" placeholder="{{prop.label}}" (change)="onChange(prop)" *ngIf="!prop.readony&&!dataObject.readonly">
                      <mat-option *ngFor="let option of prop.options" [value]="option.value">
                        {{ option.label }}
                      </mat-option>
                    </mat-select>
										<input matInput placeholder="{{prop.label}}"
										[readonly]="prop.readonly||dataObject.readonly"
										[formControlName]="prop.key"
										(change)="onChange(prop)"
										[id]="prop.key" [type]="prop.type" *ngIf="prop.readony||dataObject.readonly">
                  </mat-form-field>
                </div>

								<div *ngSwitchCase="'tag'">
									<div [ngSwitch]="prop.tag">
										<div *ngSwitchCase="'h2'">
											<h2 [ngClass]="[prop.class||'']">{{prop.content}}</h2>
										</div>
										<div *ngSwitchCase="'h3'">
											<h3 [ngClass]="[prop.class||'']">{{prop.content}}</h3>
										</div>
										<div *ngSwitchCase="'h4'">
											<h4 [ngClass]="[prop.class||'']">{{prop.content}}</h4>
										</div>
										<div *ngSwitchCase="'p'">
											<p [ngClass]="[prop.class||'']">{{prop.content}}</p>
										</div>
										<div *ngSwitchCase="'div'">
											<div [ngClass]="[prop.class||'']">{{prop.content}}</div>
										</div>
									</div>
								</div>
              </div>

            <div class="error" *ngIf="form.get(prop.key).invalid && (form.get(prop.key).dirty || form.get(prop.key).touched)">
                <div *ngIf="form.get(prop.key).errors.required">
                  {{ prop.label }} es obligatorio.
                </div>
              </div>
          </div>
        </div>
      </div>
    </form>
<!--    <hr />
    <strong>Form Value</strong>
    <pre>{{ form.value | json }}</pre>
    <strong>Form is valid:</strong> {{form.valid}}-->
  `,
    styles: [
        `
        .error { color: red; }
        `
    ],
    standalone: false
})
export class DynamicFormGroupsComponent implements OnInit {
  @Input() dataObject;
  @Input() form: UntypedFormGroup;
  objectProps;
  objectGroups;

  constructor() {
  }

  ngOnInit() {
    // remap the API to be suitable for iterating over it
    this.objectGroups =
      Object.keys(this.dataObject.groups)
        .map(prop => {
          return Object.assign({}, { key: prop} , this.dataObject.groups[prop]);
        });

    // console.log(this.dataObject);
    for (let i=0, l=this.objectGroups.length;i<l;i++) {
        this.objectGroups[i].fields = Object.keys(this.objectGroups[i].fields)
          .map(prop => {
            return Object.assign({}, { key: prop} , this.objectGroups[i].fields[prop]);
          });
    }

		if (typeof this.form === 'undefined') {
				this.form = new UntypedFormGroup({
					m: new UntypedFormControl('r')
				});
		}
    // setup the form
    const formGroup = {};
    for (let i in this.objectGroups) {
      // console.log(i, this.objectGroups);
      for (let prop in Object.keys(this.objectGroups[i].fields)) {
					// if (this.objectGroups[i].fields[prop].type !== 'group') {
							// formGroup[this.objectGroups[i].fields[prop].key] = new FormControl(this.objectGroups[i].fields[prop].value || '', this.mapValidators(this.objectGroups[i].fields[prop].validation));
							this.form.addControl(this.objectGroups[i].fields[prop].key, new UntypedFormControl(this.objectGroups[i].fields[prop].value || '', this.mapValidators(this.objectGroups[i].fields[prop].validation)));
					// }
      }
    }
		// console.log(this.form);
    // for(let prop of Object.keys(this.dataObject.fields)) {
    //   formGroup[prop] = new FormControl(this.dataObject.fields[prop].value || '', this.mapValidators(this.dataObject.fields[prop].validation));
    // }
		setTimeout(() => {
				this.onChange(this.form.controls.fecha);
		}, 500);

  }

	onChange(elem: any) {
			// console.log('changes?', elem);
			if (typeof this.dataObject.onChange !== 'undefined') {
					if (typeof this.dataObject.onChange === 'string') {
							const result = new Function("elem", this.dataObject.onChange).call(this, this.form.controls[elem.key]);
					} else {
							this.dataObject.onChange(elem);
					}
			}
	}

  evaluate(expression):boolean {
      let ret = true;
      if (typeof expression !== 'undefined' && expression !== null) {
          // ret = eval(expression);
          ret = (0, eval)(expression);
      }
      return ret;
  }

  private mapValidators(validators) {
    const formValidators = [];

    if(validators) {
      for(const validation of Object.keys(validators)) {
        if(validation === 'required') {
          formValidators.push(Validators.required);
        } else if(validation === 'min') {
          formValidators.push(Validators.min(validators[validation]));
        }
      }
    }

    return formValidators;
  }

  onSubmit(form) {
    console.log(form);
  }
}
